export const PURCHASED_POLICIES_PAGE_SIZE = 8;
export const AVAILABLE_QUOTES_PAGE_SIZE = 4;
export const SADAD_BILLS_PAGE_SIZE = 10;

export enum UserAccountActiveTabEnum {
  PURCHASED_POLICIES = "purchased_policies",
  AVAILABLE_QUOTES = "available_quotes",
  PENDING_POLICIES = "pending_policies",
  SADAD_BILLS = "sadad_bills",
}
